"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencySymbolForString = void 0;
const currencySymbolForString = function () {
  let currencyString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "USD";
  return "$";
};
exports.currencySymbolForString = currencySymbolForString;
exports.default = exports.currencySymbolForString;